import { render, staticRenderFns } from "./nickNameView.vue?vue&type=template&id=051961d3&scoped=true&"
import script from "./nickNameView.vue?vue&type=script&lang=js&"
export * from "./nickNameView.vue?vue&type=script&lang=js&"
import style0 from "./nickNameView.vue?vue&type=style&index=0&id=051961d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051961d3",
  null
  
)

export default component.exports